{
  "serviceForms": {
    "joinCorporateForm": {
      "fields": {
        "iataNumber": {
          "pattern": "IATA-numero voi sisältää vain 7 tai 8 merkkiä."
        }
      }
    }
  }
}
